
import { Label } from "@/components/ui/label";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { ImageUploadSection } from "../ImageUploadSection";
import { cn } from "@/lib/utils";
import { EventImage } from "../image-upload/imageUploadUtils";
import { DeadlineTimerSection } from "./DeadlineTimerSection";

interface DetailsSectionProps {
  title: string;
  description: string;
  titleError?: string;
  imageUrl: string;
  imageUrls: string[];
  onTitleChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onDescriptionChange: (e: React.ChangeEvent<HTMLTextAreaElement>) => void;
  setImageUrl: (url: string) => void;
  setImageUrls: (urls: string[]) => void;
  eventId?: string;
  // New props for handling direct EventImage array
  eventImages?: EventImage[];
  setEventImages?: (images: EventImage[]) => void;
  // New props for deadline
  eventDeadline: Date | null;
  onDeadlineChange: (deadline: Date | null) => void;
}

export const DetailsSection = ({
  title,
  description,
  titleError,
  imageUrl,
  imageUrls = [],
  onTitleChange,
  onDescriptionChange,
  setImageUrl,
  setImageUrls,
  eventId,
  eventImages,
  setEventImages,
  eventDeadline,
  onDeadlineChange
}: DetailsSectionProps) => {
  return (
    <div className="space-y-6">
      <div className="space-y-2">
        <Label htmlFor="title">Event Title</Label>
        <Input 
          id="title" 
          placeholder="Enter event title (e.g., Birthday Party)" 
          value={title} 
          onChange={onTitleChange} 
          className={cn(titleError && "border-destructive")}
        />
        {titleError && <p className="text-sm text-destructive">{titleError}</p>}
      </div>

      <div className="space-y-2">
        <Label htmlFor="description">Event Description</Label>
        <Textarea 
          id="description" 
          placeholder="Describe your event (e.g., themes, agenda)" 
          value={description} 
          onChange={onDescriptionChange} 
          className="min-h-[100px]" 
        />
      </div>

      <DeadlineTimerSection 
        eventDeadline={eventDeadline}
        onDeadlineChange={onDeadlineChange}
      />

      <ImageUploadSection 
        imageUrl={imageUrl} 
        imageUrls={imageUrls}
        setImageUrl={setImageUrl} 
        setImageUrls={setImageUrls}
        eventId={eventId}
        eventImages={eventImages}
        setEventImages={setEventImages}
      />
    </div>
  );
};
